import { render, staticRenderFns } from "./row-vxe-provider.vue?vue&type=template&id=4df62a95"
import script from "./row-vxe-provider.vue?vue&type=script&lang=js"
export * from "./row-vxe-provider.vue?vue&type=script&lang=js"
import style0 from "./row-vxe-provider.vue?vue&type=style&index=0&id=4df62a95&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports